/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateCompanyResponseData,
  CreateCompanyResponseDataFromJSON,
  CreateCompanyResponseDataFromJSONTyped,
  CreateCompanyResponseDataToJSON
} from './CreateCompanyResponseData'

/**
 *
 * @export
 * @interface GetCompanyResponse
 */
export interface GetCompanyResponse {
  /**
   *
   * @type {number}
   * @memberof GetCompanyResponse
   */
  status?: number
  /**
   *
   * @type {CreateCompanyResponseData}
   * @memberof GetCompanyResponse
   */
  data?: CreateCompanyResponseData
}

export function GetCompanyResponseFromJSON(json: any): GetCompanyResponse {
  return GetCompanyResponseFromJSONTyped(json, false)
}

export function GetCompanyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompanyResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateCompanyResponseDataFromJSON(json['data'])
  }
}

export function GetCompanyResponseToJSON(value?: GetCompanyResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateCompanyResponseDataToJSON(value.data)
  }
}
